<app-selector label="Orderings Game" [isEmptySelectable]="isEmptySelectable" [data]="orderingGameCoreService.orderingGameList$| async"
    displayKey="name" [formControl]="ctrl" (refreshEvent)="refresh()" hintStyle="margin-left: -14px; margin-top: -5px" [loading]="orderingGameCoreService.loading"
    [hint]="hint">
</app-selector>